import { AtomStore } from '../utils/AtomStore';

export const store = new AtomStore();
